import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-open-call-operator',
  templateUrl: './open-call-operator.component.html',
  styleUrls: ['./open-call-operator.component.scss']
})
export class OpenCallOperatorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
